/* =====================================================================
   THRIFT THREADS — bold editorial motion (homepage only)
   Progressive enhancement:
     • An inline <head> script adds `.motion` to <html> (pre-paint) unless
       the visitor prefers reduced motion, and removes it after a timeout if
       this file never confirms init — so content is NEVER stuck hidden.
     • CSS gates all "hidden until revealed" states on `.motion`.
   Requires GSAP + ScrollTrigger (self-hosted). Lenis smooth scroll optional.
   ===================================================================== */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains("motion")) return; // reduced motion / disabled
  if (!(window.gsap && window.ScrollTrigger)) { root.classList.remove("motion"); return; }

  var gsap = window.gsap;
  gsap.registerPlugin(window.ScrollTrigger);

  // --- Lenis smooth scroll (optional, guarded) ---
  try {
    if (window.Lenis) {
      var lenis = new window.Lenis({ lerp: 0.11, smoothWheel: true, wheelMultiplier: 1 });
      lenis.on("scroll", window.ScrollTrigger.update);
      gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
      gsap.ticker.lagSmoothing(0);
    }
  } catch (e) { /* smooth scroll is a nicety; ignore failures */ }

  function done() { window.__edMotionReady = true; }

  function init() {
    var scope = document.querySelector('#MainContent[data-template="index"]');
    if (!scope) { root.classList.remove("motion"); done(); return; }

    try {
      // HERO — headline / text / buttons rise + fade on load; image parallax
      var hero = scope.querySelector('[id*="__hero"]');
      if (hero) {
        var ht = hero.querySelectorAll(".banner__heading, .banner__text, .banner__buttons");
        if (ht.length) {
          gsap.to(ht, {
            autoAlpha: 1, yPercent: 0, duration: 1.35, ease: "power4.out",
            stagger: 0.14, delay: 0.15, startAt: { yPercent: 75, autoAlpha: 0 }
          });
        }
        // (hero image already has the theme's ambient zoom — no extra parallax to avoid conflict)
      }

      // SCROLL REVEALS — batched, staggered
      var revealSel = [
        '[id*="__rich_intro"] .rich-text__blocks > *',
        '[id*="__value_props"] .multicolumn-list__item',
        '[id*="__collection_list_bCAkXg"] .collection-list-title',
        '[id*="__collection_list_bCAkXg"] .collection-list__item',
        '[id*="__featured_blog_WVccPQ"] .title',
        '[id*="__featured_blog_WVccPQ"] .card',
        '[id*="__multicolumn_pjnX7B"] .multicolumn-list__item',
        '.ed-statement__line'
      ].join(",");
      var revealEls = scope.querySelectorAll(revealSel);
      if (revealEls.length) {
        window.ScrollTrigger.batch(revealEls, {
          start: "top 88%",
          onEnter: function (els) {
            gsap.to(els, { autoAlpha: 1, y: 0, scale: 1, duration: 1.05, ease: "power4.out", stagger: 0.13, overwrite: true });
          }
        });
      }

      // IMAGE PARALLAX — category tiles + about images
      scope.querySelectorAll('[id*="__collection_list_bCAkXg"] .media img, [id*="__multicolumn_pjnX7B"] .media img')
        .forEach(function (img) {
          var trig = img.closest(".collection-list__item, .multicolumn-card") || img;
          gsap.fromTo(img, { yPercent: -10, scale: 1.25 },
            { yPercent: 10, scale: 1.25, ease: "none",
              scrollTrigger: { trigger: trig, start: "top bottom", end: "bottom top", scrub: true } });
        });

      // STATEMENT — scrub zoom for a heavy, dramatic pass-through
      var stmt = scope.querySelector(".ed-statement");
      if (stmt) {
        var slines = stmt.querySelector(".ed-statement__lines");
        if (slines) {
          gsap.fromTo(slines, { scale: 0.9 },
            { scale: 1.08, ease: "none",
              scrollTrigger: { trigger: stmt, start: "top bottom", end: "bottom top", scrub: 0.5 } });
        }
      }

      window.ScrollTrigger.refresh();
    } catch (e) {
      // If anything blew up, make sure nothing stays hidden.
      root.classList.remove("motion");
    }
    done();
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);

  // Re-measure once everything (fonts/images) has loaded.
  window.addEventListener("load", function () { try { window.ScrollTrigger.refresh(); } catch (e) {} });
})();
